const onLazyLoadedImageIntersection = (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
  entries.forEach((entry: IntersectionObserverEntry) => {
    const image = entry.target
    if (entry.isIntersecting && !image.getAttribute('src')) {
      image.setAttribute('src', image.getAttribute('data-src') ?? '')
      observer.unobserve(image)
    }
  })
}

const IMAGE_OBSERVER = globalThis.window
  ? new IntersectionObserver(onLazyLoadedImageIntersection, { rootMargin: '100px' })
  : null

export const observeLazyLoadedChildrenImages = (parentNode: ParentNode | null) => {
  parentNode?.querySelectorAll('img[data-src]').forEach((element: Element) => {
    IMAGE_OBSERVER?.observe(element)
  })
}
